import {useEffect, useState} from "react";

export const useOpaqueOnMount = (timeout = 0) => {
  const [isOpaque, setIsOpaque] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsOpaque(true);
    }, timeout);

    return () => clearTimeout(timeoutId);
  }, [timeout])

  return isOpaque;
}